<template>
    <div class="card" @click="goPubilcDetail(detail)">
        <div class="cardimg cardvideoimg" v-if="detail.isVideo==1">
            <div class="play">
                <img src="@/assets/images/home/stop.png" alt="">
            </div>
            <div class="times" v-if="detail.isVideo==1&&detail.duration">
                {{$utils.durationTrans(detail.duration)}}
            </div>
            <div class="times" v-else-if="detail.isVideo==1&&detail.duration==undefined">
                <img style="border-radius:0;" src="@/assets/images/home/camera.png" alt="">
            </div>
            <img :src="detail.coverImg" alt="">
        </div>
        <div class="cardimg cardotherimg" v-else>
            <img :src="detail.coverImg" alt="">
        </div>
        <ul class="cardinfo">
            <li class="ctitle" :title="detail.title">
                {{detail.title}}
            </li>
            <li class="cname" :title="detail.author">
                {{ $t('components.historyCard.953678-0') }}{{detail.author}}
            </li>
            <li class="cname" v-if="showGrade">
                {{gradeName(detail.grade)}}
                {{detail.subjectName}}
            </li>
            <li class="nums">
                <div>
                    <img src="@/assets/images/home/z1.png" alt="">
                    <span>{{detail.browseCount}}</span>
                </div>
                <div>
                    <img src="@/assets/images/home/z2.png" alt="">
                    <span>{{detail.praiseCount}}</span>
                </div>
                <div>
                    <img src="@/assets/images/home/z3.png" alt="">
                    <span>{{detail.collectCount}}</span>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    props:{
        detail:{
            type:Object,
            default:()=>{}
        },
        gradeList:{
            type:Array,
            default:()=>[]
        },
        showGrade:{
            type:Boolean,
            default:false
        },
        // path: {
        //     type: String,
        //     default: '/home/pubilcdetail'
        // },
        origin:{
            type:Number,
            default:1
        }
    },
    methods:{
        gradeName(val){
            return  this.gradeList[val] && this.gradeList[val].name ;
        },
        goPubilcDetail(item){
            let str = '';
            switch (this.origin) {
                case 1:
                    str = '/teacherClass/detail';//名师
                    break;
                case 2:
                    str = '/schoolClass/detail';//名校
                    break;
                case 3:
                    str = '/courierclass/courierdetail';//专递
                    break;
            
                default:
                    break;
            }
            this.$router.push({path: str,query:{id:item.id,browseType:1}});
        }
    }
}
</script>
<style lang="less" scoped>
.card:hover .ctitle,.card:hover .cname{
    color:#009A3E !important;
}
.card:hover .play{
    opacity: 1 !important;
    transform: scale(1) !important;
}
.card{
    width: 224px;
    // height: 215px;
    background: #ffffff;
    cursor: pointer;
    border-radius: 10px;
    .cardimg{
        width:224px;
        height: 125px;
        position: relative;
        img{
            width:100%;
            height: 100%;
            border-radius: 10px 10px 0px 0px;
        }
    }
    .cardvideoimg{
        position: relative;
        .play{
            opacity: 0;
            position: absolute;
            color:#fff;
            top:50%;
            left:50%;
            margin-left:-16px;
            margin-top:-16px;
            width:32px;
            height: 32px;
            transform: scale(1.2);
            transition: 0.1s linear;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .times{
            position: absolute;
            right:5px;
            bottom:4px;
            color:#fff;
            font-size: 12px;
            padding:1px 7px;
            background: rgba(0,0,0,0.3);
            border-radius: 8px;
            img{
                width:9px;
                height: 8px;
            }
        }
    }
    .cardotherimg{

    }
    .cardinfo{
        overflow: hidden;
        font-size: 13px;
        padding-bottom: 10px;
        li{
            margin:10px 10px 0 10px;
        }
        .ctitle{
            font-weight: 700;
            color:#333;
            overflow:hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
        }
        .cname{
            font-weight: 400;
            color:#666;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .nums{
            font-weight: 400;
            color:#999;
            display: flex;
            justify-content: space-between;
            div{
                display: flex;
                align-items: center;
                img{
                    width:16px;
                    height: 16px;
                    margin-right: 3px;
                }
            }
        }
    }
}
</style>